/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import {connect} from 'react-redux';

import Header from './Header';

/**
 * Map state from the Redux store to properties on the component.
 *
 * @param state state from the redux store.
 */
const mapStateToProps = state => {
  return {
    user: state.user,
    custSandboxEnv: state.custSandboxEnv
  };
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/Header/HeaderContainer.js